import { webEnums } from '@vectronic/openApi-admin';

export const roleOrder = new Map<webEnums.Role, number>([
  ['OWNER', 0],
  ['DEVICE_MANAGER', 1],
  ['DATA_MANAGER', 2],
  ['READER', 3],
]);
